import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class CompanyApi {

    async getProfiles(search_execution_id: string, search: SearchesModel) {
      try {
          const response = await axios.post(`${API_URL}/api/data-sections/company/profiles`, { search_execution_id, search },
              {
                  headers: authHeader(),
              });

          return response.data as ResponseSuccessModel;
      } catch (error) {
        return handleAxiosError(error);
      }
  }

    async getCompanyProfileFinancials(search_execution_id: string, company_key: string) {
      try {
          const response = await axios.post(`${API_URL}/api/data-sections/company/profile-financials`, { search_execution_id, company_key },
              {
                  headers: authHeader(),
              });

          return response.data as ResponseSuccessModel;
      } catch (error) {
        return handleAxiosError(error);
      }
  }

}

const companyApi = new CompanyApi();
export default companyApi;
